import type { IconProps } from "./icon-types";

/**
 * 과녁(동심원 3겹). 평가/정확도/목표 표시에 사용(제품 의미 부여는 소비 앱의 semantic
 * alias 책임).
 *
 * 커스텀 드로잉 — c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split
 * §아이콘). 24 그리드 / stroke 기반.
 */
export const TargetIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </svg>
);
